import { render, staticRenderFns } from "./PhotoVerification.vue?vue&type=template&id=411e16a3&"
import script from "./PhotoVerification.vue?vue&type=script&lang=ts&"
export * from "./PhotoVerification.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports